module.exports = __webpack_public_path__ + "static/media/mia.c66058da.jpg";